import { useEffect, useRef, useState } from 'react';

/**
 * Хук определяет имеет ли скролл элемент
 */
export const useHasScroll = <T extends HTMLElement | null>(element: T) => {
  const [isScroll, setIsScroll] = useState<boolean>(false);

  const resizeObserver = useRef(
    new ResizeObserver((entries) => {
      const target = entries[0].target;
      setIsScroll(target.scrollHeight > target.clientHeight);
    }),
  );

  useEffect(() => {
    if (!element) {
      setIsScroll(false);
    } else {
      resizeObserver.current.observe(element);

      setIsScroll(element.scrollHeight > element.clientHeight);

      return () => {
        resizeObserver.current.disconnect();
      };
    }
  }, [element]);

  return { isScroll };
};
